import { createContext, useContext } from "react";
import type { AuthRoleState } from "@/hooks/useAuthRole";

export const AdminSessionContext = createContext<AuthRoleState | null>(null);

const EMPTY_STATE: AuthRoleState = {
  session: null,
  role: null,
  username: null,
  loading: true,
  isAdmin: false,
  isMatchmaker: false,
  reload: async () => {},
};

export function useAdminSession(): AuthRoleState {
  return useContext(AdminSessionContext) || EMPTY_STATE;
}

export default AdminSessionContext;